module.exports = __webpack_public_path__ + "static/onboarding_banner.04500212.jpg";